import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UiState {
    isMobileMenuVisible: boolean;
    isActionMobileSectionVisible: boolean;
}

const initialState: UiState = {
    isMobileMenuVisible: true,
    isActionMobileSectionVisible: false,
};

const uiSlice = createSlice({
    name: 'ui',
    initialState,
    selectors: {
        isMobileMenuVisible: (state) => state.isMobileMenuVisible,
        isActionMobileSectionVisible: (state) => state.isActionMobileSectionVisible,
    },
    reducers: {
        setMobileMenuVisibility: (state, action: PayloadAction<boolean>) => {
            state.isMobileMenuVisible = action.payload;
        },
        toggleMobileMenu: (state) => {
            state.isMobileMenuVisible = !state.isMobileMenuVisible;
        },
        setActionMobileSectionVisibility: (state, action: PayloadAction<boolean>) => {
            state.isActionMobileSectionVisible = action.payload;
        },
        toggleActionMobileSection: (state) => {
            state.isActionMobileSectionVisible = !state.isActionMobileSectionVisible;
        },
    },
});

export const { actions: uiActions, selectors: uiSelectors } = uiSlice;

export default uiSlice.reducer;
